module.exports = __webpack_public_path__ + "img/info_banner.c16fd962.png";